import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.search');
import { OnInit, OnDestroy, HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-search',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.search/view.scss */
:host {
  display: block;
  height: 100%;
}

.keyword-researcher-card {
  height: 224px;
  overflow: hidden;
}

.matched-keyword-preview {
  max-height: 44px;
}

.keyword-expansion-wave-text {
  display: inline-flex;
  align-items: baseline;
  flex-wrap: wrap;
  line-height: 1.5;
  white-space: normal;
}

.keyword-expansion-wave-char {
  display: inline-block;
  animation: keyword-expansion-char-wave 1.15s ease-in-out infinite;
}

.keyword-expansion-wave-space {
  display: inline-block;
  width: 0.35em;
}

.facet-loading-wave {
  display: inline-block;
  color: transparent;
  background: linear-gradient(90deg, #4A6FD8 0%, #8EA3F3 35%, #2C4A99 70%, #4A6FD8 100%);
  background-size: 220% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  animation: facet-text-wave 1.45s ease-in-out infinite;
}

.facet-skeleton-shimmer {
  position: relative;
  overflow: hidden;
  background: #f3f4f6;
}

.facet-skeleton-shimmer::after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.85), transparent);
  animation: facet-skeleton-wave 1.35s ease-in-out infinite;
}

.facet-skeleton-chip-org {
  width: 4rem;
}

.facet-skeleton-chip-org:nth-child(2n) {
  width: 5rem;
}

.facet-skeleton-chip-org:nth-child(3n) {
  width: 6rem;
}

.facet-skeleton-chip-keyword {
  width: 3.5rem;
}

.facet-skeleton-chip-keyword:nth-child(2n) {
  width: 7rem;
}

.facet-skeleton-chip-keyword:nth-child(3n) {
  width: 5rem;
}

.expanded-keyword-list-collapsed {
  max-height: 1.625rem;
  overflow: hidden;
}

@keyframes facet-text-wave {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@keyframes keyword-expansion-char-wave {
  0%, 60%, 100% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-0.28em);
  }
}
@keyframes facet-skeleton-wave {
  100% {
    transform: translateX(100%);
  }
}
@media (prefers-reduced-motion: reduce) {
  .keyword-expansion-wave-char {
    animation: none;
  }
}`],
})
export class PageSearchComponent implements OnInit, OnDestroy {
    private static SEARCH_STATE_KEY = 'korenet_search_state_v6_source_keyword_labels';
    private static LEGACY_SEARCH_STATE_KEYS = [
        'korenet_search_state',
        'korenet_search_state_v2_full_facets',
        'korenet_search_state_v3_collapsed_facets',
        'korenet_search_state_v4_default_exact_keyword',
        'korenet_search_state_v5_raw_keyword_labels'
    ];
    private static AGENT_SUMMARY_KEY = 'agent_recommendation_summary';
    private static AGENT_RESEARCHERS_KEY = 'agent_recommended_researchers';
    private static AGENT_QUERY_KEY = 'agent_recommendation_query';

    public searchTab: string = 'researcher';
    public renderedSearchTab: string = 'researcher';
    public searchTabDropdownOpen: boolean = false;
    public searchText: string = '';
    public renderedSearchText: string = '';
    public fuzzySearch: boolean = false;
    public renderedFuzzySearch: boolean = false;
    public page: number = 1;
    public dump: number = 10;
    public total: number = 0;
    public rows: any[] = [];
    public loading: boolean = false;
    public researcherLoadingCardVisible: boolean = false;
    public researcherLoadingMessage: string = '메모리에서 연구자 목록을 가져오는 중입니다.';
    public lastPage: number = 1;

    public sort: string = 'total';
    public order: string = 'DESC';
    public sortOptions: any[] = [
        { value: 'match', label: '연구 영향력순' },
        { value: 'total', label: '총 성과물순' },
        { value: 'paper', label: '논문순' },
        { value: 'patent', label: '특허순' },
        { value: 'report', label: '보고서순' }
    ];
    public searchTabOptions: any[] = [
        { value: 'researcher', label: '연구자' },
        { value: 'keyword', label: '키워드' }
    ];
    private readonly keywordSortValues: string[] = ['match', 'paper', 'report', 'patent'];
    private readonly matchedKeywordPreviewCandidateLimit: number = 30;
    private readonly matchedKeywordMoreThreshold: number = 3;

    public popoverCardId: string = '';
    public matchedKeywordModalRow: any = null;
    public showFilters: boolean = false;
    public showEmptyGuide: boolean = true;

    // 에이전트 추천 결과 모드
    public agentMode: boolean = false;
    public agentSummary: string = '';

    // 패싯 네비게이터
    public facets: any = { orgs: [], keywords: [] };
    public selectedOrgs: string[] = [];
    public selectedKeywords: string[] = [];
    public expandedKeywords: string[] = [];
    public showAllExpandedKeywords: boolean = false;
    public keywordExpansionActive: boolean = false;
    public keywordExpansionSlow: boolean = false;
    public keywordExpansionElapsedSeconds: number = 0;
    public keywordExpansionModelError: string = '';
    public keywordSearchStatusErrorTitle: string = '';
    public keywordSearchStatusError: string = '';
    public keywordExpansionMessage: string = 'AI 키워드 확장 후 연구자 집계중입니다. 잠시만 기다려주세요.';
    public keywordExpansionMessageChars: any[] = [];
    public facetLoading: boolean = false;
    public facetPreparingMessage: string = '상세 필터 준비 중입니다. 백그라운드에서 계속 집계하고 있습니다.';
    public facetSkeletonVisible: boolean = false;
    public loadingSkeletonCards: number[] = [1, 2, 3, 4, 5, 6];
    public facetSkeletonChips: number[] = [1, 2, 3, 4, 5, 6, 7, 8];
    public showFacetPanel: boolean = false;
    public openFacetCategory: string = '';
    public showAllOrgs: boolean = false;
    public keywordsLimit: number = 30;

    private agentResultHandler: any = null;
    private facetRequestSeq: number = 0;
    private keywordSearchRequestSeq: number = 0;
    private sortRequestInFlight: boolean = false;
    private keywordResultCacheToken: string = '';
    private keywordExpansionTimer: any = null;
    private keywordExpansionStartedAt: number = 0;
    private keywordExpansionPromptDismissed: boolean = false;
    private facetSkeletonTimer: any = null;
    private facetPollTimer: any = null;
    private readonly facetSkeletonDelayMs: number = 300;
    private readonly expandedKeywordCollapsedPreviewCount: number = 10;
    private keywordExpansionModelNotice: string = '확장어를 가져오지 못해 입력 키워드 기준으로 검색했습니다.';

    constructor(@Inject( Service) public service: Service) {
        this.setKeywordExpansionMessage(this.keywordExpansionMessage);
    }

    private ensureKeywordResultCacheToken(): string {
        if (!this.keywordResultCacheToken) {
            this.keywordResultCacheToken = [
                Date.now().toString(36),
                Math.random().toString(36).slice(2, 10)
            ].join('-');
        }
        return this.keywordResultCacheToken;
    }

    private normalizeSearchTab(tab: string | null): string {
        return tab === 'keyword' ? 'keyword' : 'researcher';
    }

    private getDefaultFuzzy(tab: string = this.searchTab): boolean {
        return false;
    }

    private normalizeFuzzy(tab: string = this.searchTab, fuzzy: boolean = this.fuzzySearch): boolean {
        return this.normalizeSearchTab(tab) === 'keyword' && fuzzy;
    }

    private enforceFuzzyForCurrentTab(): boolean {
        const normalized = this.normalizeFuzzy(this.searchTab, this.fuzzySearch);
        if (this.fuzzySearch !== normalized) {
            this.fuzzySearch = normalized;
        }
        return normalized;
    }

    private readFuzzyParam(params: URLSearchParams, tab: string = this.searchTab): boolean {
        const value = params.get('fuzzy');
        const requested = value === 'true'
            ? true
            : (value === 'false' ? false : this.getDefaultFuzzy(tab));
        return this.normalizeFuzzy(tab, requested);
    }

    private getDefaultSort(tab: string = this.searchTab): string {
        return tab === 'keyword' ? 'match' : 'total';
    }

    public get activeSortOptions(): any[] {
        return this.sortOptionsForTab(this.renderedSearchTab);
    }

    public get selectedSearchTabOption(): any {
        return this.searchTabOptions.find((option: any) => option.value === this.searchTab) || this.searchTabOptions[0];
    }

    private sortOptionsForTab(tab: string = this.searchTab): any[] {
        if (this.normalizeSearchTab(tab) === 'keyword') {
            return this.keywordSortValues
                .map((value: string) => this.sortOptions.find((option: any) => option.value === value))
                .filter((option: any) => option);
        }
        return this.sortOptions.filter((option: any) => option.value !== 'match');
    }

    private normalizeSort(sort: string | null, tab: string = this.searchTab): string {
        const defaultSort = this.getDefaultSort(tab);
        const value = String(sort || defaultSort);
        const options = this.sortOptionsForTab(tab);
        return options.some((option: any) => option.value === value) ? value : defaultSort;
    }

    private getRenderedSearchText(): string {
        return String(this.renderedSearchText || '').trim();
    }

    private getSearchTextForResult(): string {
        return this.getRenderedSearchText() || String(this.searchText || '').trim();
    }

    private isKeywordResultMode(): boolean {
        return this.normalizeSearchTab(this.renderedSearchTab) === 'keyword';
    }

    private setRenderedSearchState(tab: string, text: string, fuzzy: boolean = this.fuzzySearch) {
        const nextTab = this.normalizeSearchTab(tab);
        const nextText = String(text || '').trim();
        this.renderedSearchTab = nextTab;
        this.renderedSearchText = nextText;
        this.renderedFuzzySearch = this.normalizeFuzzy(nextTab, fuzzy);
    }

    private resetFacetState(clearSelections: boolean = true) {
        if (clearSelections) {
            this.selectedOrgs = [];
            this.selectedKeywords = [];
        }
        this.facets = { orgs: [], keywords: [] };
        this.expandedKeywords = [];
        this.showAllExpandedKeywords = false;
        this.showFilters = false;
        this.showAllOrgs = false;
        this.keywordsLimit = 30;
        this.showFacetPanel = false;
        this.openFacetCategory = '';
        this.facetRequestSeq++;
        this.stopFacetLoading();
    }

    private clearRenderedResultsForNewSearch() {
        this.rows = [];
        this.total = 0;
        this.lastPage = 1;
        this.popoverCardId = '';
        this.matchedKeywordModalRow = null;
    }

    private readSavedSearchState(): any {
        try {
            const raw = sessionStorage.getItem(Component.SEARCH_STATE_KEY);
            return raw ? JSON.parse(raw) : null;
        } catch {
            return null;
        }
    }

    private clearSavedSearchState() {
        try {
            sessionStorage.removeItem(Component.SEARCH_STATE_KEY);
        } catch { }
    }

    private clearLegacySearchState() {
        try {
            Component.LEGACY_SEARCH_STATE_KEYS.forEach((key: string) => sessionStorage.removeItem(key));
        } catch { }
    }

    private hasSavedSearchResults(state: any): boolean {
        return Array.isArray(state?.rows) && (state.rows.length > 0 || Number(state?.total || 0) > 0);
    }

    private savedSearchMatchesUrl(state: any, params: URLSearchParams): boolean {
        if (!this.hasSavedSearchResults(state)) return false;

        const agentIds = params.get('agent_ids');
        if (agentIds) return state.agentMode === true;

        const query = params.get('q');
        if (!query) return true;

        const urlTab = this.normalizeSearchTab(params.get('tab'));
        const urlSort = this.normalizeSort(params.get('sort'), urlTab);
        const urlPage = parseInt(params.get('page') || '1');
        const urlFuzzy = this.readFuzzyParam(params, urlTab);
        const stateTab = this.normalizeSearchTab(state.renderedSearchTab || state.searchTab || 'researcher');
        const stateText = String(state.renderedSearchText || state.searchText || '');
        const stateSort = this.normalizeSort(state.sort || null, stateTab);
        const rawStateFuzzy = typeof state.renderedFuzzySearch === 'boolean'
            ? state.renderedFuzzySearch
            : state.fuzzySearch;
        if (stateTab === 'researcher' && rawStateFuzzy === true) {
            return false;
        }
        const stateFuzzy = this.normalizeFuzzy(
            stateTab,
            typeof rawStateFuzzy === 'boolean' ? rawStateFuzzy : this.getDefaultFuzzy(stateTab)
        );

        return stateText === query
            && stateTab === urlTab
            && stateSort === urlSort
            && Number(state.page || 1) === urlPage
            && stateFuzzy === urlFuzzy;
    }

    private restoreSavedSearchState(state: any, restoreResults: boolean = false): boolean {
        if (!state) return false;

        const restoredRenderedTab = this.normalizeSearchTab(state.renderedSearchTab || state.searchTab || 'researcher');
        const restoredDraftTab = this.normalizeSearchTab(state.searchTab || restoredRenderedTab);
        this.renderedSearchTab = restoredRenderedTab;
        this.renderedSearchText = String(state.renderedSearchText || state.searchText || '').trim();
        this.searchText = state.searchText || this.renderedSearchText || '';
        this.searchTab = restoredDraftTab;
        this.sort = this.normalizeSort(state.sort || null, this.renderedSearchTab);
        this.order = state.order || 'DESC';
        this.page = Number(state.page || 1);
        this.dump = Number(state.dump || this.dump || 10);
        this.fuzzySearch = this.normalizeFuzzy(
            this.searchTab,
            typeof state.fuzzySearch === 'boolean' ? state.fuzzySearch : this.getDefaultFuzzy(this.searchTab)
        );
        this.renderedFuzzySearch = this.normalizeFuzzy(
            this.renderedSearchTab,
            typeof state.renderedFuzzySearch === 'boolean' ? state.renderedFuzzySearch : this.fuzzySearch
        );
        this.selectedOrgs = this.toStringArray(state.selectedOrgs);
        this.selectedKeywords = this.toStringArray(state.selectedKeywords);
        this.expandedKeywords = this.toStringArray(state.expandedKeywords);
        this.showAllExpandedKeywords = state.showAllExpandedKeywords === true;
        this.keywordExpansionModelError = String(state.keywordExpansionModelError || '');
        this.keywordSearchStatusErrorTitle = String(state.keywordSearchStatusErrorTitle || '');
        this.keywordSearchStatusError = String(state.keywordSearchStatusError || '');
        this.clearKeywordFacetStatusError();
        this.agentMode = state.agentMode === true;
        this.agentSummary = String(state.agentSummary || '');
        this.showFilters = state.showFilters === true;
        this.showAllOrgs = state.showAllOrgs === true;
        this.keywordsLimit = Math.max(30, Number(state.keywordsLimit || 30));
        this.loading = false;
        this.stopFacetLoading();
        this.keywordExpansionActive = false;
        this.keywordExpansionSlow = false;
        this.keywordExpansionElapsedSeconds = 0;

        if (!restoreResults || !this.hasSavedSearchResults(state)) {
            return false;
        }

        this.rows = state.rows || [];
        this.total = Number(state.total || this.rows.length || 0);
        this.lastPage = Number(state.lastPage || Math.ceil(this.total / this.dump) || 1);
        this.facets = {
            orgs: Array.isArray(state.facets?.orgs) ? state.facets.orgs : [],
            keywords: Array.isArray(state.facets?.keywords) ? state.facets.keywords : []
        };
        this.facets = this.normalizeFacetPayload(this.facets);
        this.showEmptyGuide = this.rows.length === 0 && !this.getRenderedSearchText() && !this.agentMode;
        return true;
    }

    private buildSearchStateSnapshot(): any {
        return {
            searchText: this.searchText,
            searchTab: this.searchTab,
            renderedSearchText: this.renderedSearchText,
            renderedSearchTab: this.renderedSearchTab,
            page: this.page,
            dump: this.dump,
            total: this.total,
            lastPage: this.lastPage,
            sort: this.sort,
            order: this.order,
            fuzzySearch: this.normalizeFuzzy(this.searchTab, this.fuzzySearch),
            renderedFuzzySearch: this.normalizeFuzzy(this.renderedSearchTab, this.renderedFuzzySearch),
            selectedOrgs: [...this.selectedOrgs],
            selectedKeywords: [...this.selectedKeywords],
            expandedKeywords: [...this.expandedKeywords],
            showAllExpandedKeywords: this.showAllExpandedKeywords,
            keywordExpansionModelError: this.keywordExpansionModelError,
            keywordSearchStatusErrorTitle: this.keywordSearchStatusErrorTitle,
            keywordSearchStatusError: this.keywordSearchStatusError,
            agentMode: this.agentMode,
            agentSummary: this.agentSummary,
            showEmptyGuide: this.showEmptyGuide,
            showFilters: this.showFilters,
            showAllOrgs: this.showAllOrgs,
            keywordsLimit: this.keywordsLimit,
            rows: this.rows || [],
            facets: this.facets || { orgs: [], keywords: [] },
            savedAt: Date.now()
        };
    }

    private saveSearchStateSnapshot() {
        try {
            sessionStorage.setItem(Component.SEARCH_STATE_KEY, JSON.stringify(this.buildSearchStateSnapshot()));
        } catch { }
    }

    public async ngOnInit() {
        await this.service.init();
        this.clearLegacySearchState();
        const params = new URLSearchParams(location.search);
        this.searchText = params.get('q') || '';
        this.searchTab = this.normalizeSearchTab(params.get('tab'));
        this.renderedSearchText = this.searchText;
        this.renderedSearchTab = this.searchTab;
        this.sort = this.normalizeSort(params.get('sort'), this.searchTab);
        this.page = parseInt(params.get('page') || '1');
        this.fuzzySearch = this.readFuzzyParam(params, this.searchTab);
        this.renderedFuzzySearch = this.fuzzySearch;

        // sessionStorage에서 검색 상태 복원 (뒤로가기 시)
        const saved = this.readSavedSearchState();
        const restoreCachedResults = this.savedSearchMatchesUrl(saved, params);
        if (saved && (restoreCachedResults || (!params.get('q') && !params.get('agent_ids')))) {
            this.restoreSavedSearchState(saved, restoreCachedResults);
            // URL로 다시 진입한 검색은 저장된 미실행 draft보다 URL 조건을 우선한다.
            if (restoreCachedResults && params.get('q') && !params.get('agent_ids')) {
                this.searchText = params.get('q') || '';
                this.searchTab = this.normalizeSearchTab(params.get('tab'));
                this.fuzzySearch = this.readFuzzyParam(params, this.searchTab);
            }
            this.clearSavedSearchState();
        } else if (saved) {
            this.clearSavedSearchState();
        }

        // 에이전트 결과 ID로 직접 진입
        const agentIds = params.get('agent_ids');
        if (restoreCachedResults) {
            this.showEmptyGuide = this.rows.length === 0 && !this.getRenderedSearchText() && !this.agentMode;
            if (!this.agentMode) {
                this.updateUrlParams();
            }
            await this.service.render();
            if (!this.agentMode && this.getRenderedSearchText() && !this.hasFacetData && !this.keywordSearchStatusError) {
                if (this.isKeywordResultMode()) {
                    this.loadKeywordFacets();
                } else {
                    this.loadFacets();
                }
            }
        } else if (agentIds) {
            this.searchTab = 'researcher';
            this.fuzzySearch = false;
            this.setRenderedSearchState('researcher', this.searchText, false);
            this.showEmptyGuide = false;
            this.agentSummary = '';
            await this.loadByIds(agentIds.split(',').map(id => id.trim()).filter(id => id));
            this.agentMode = true;
            await this.service.render();
        } else if (this.searchText.trim()) {
            this.showEmptyGuide = false;
            if (this.searchTab === 'keyword') {
                const keywordLoaded = await this.loadByKeyword();
                if (keywordLoaded) {
                    this.loadKeywordFacets();
                }
            } else {
                await this.load();
                this.loadFacets();
            }
            await this.service.render();
        } else {
            await this.service.render();
        }

        // 챗봇에서 에이전트 결과를 받기 위한 이벤트 리스너
        this.agentResultHandler = async (e: any) => {
            const ids = e.detail?.ids || [];
            if (ids.length > 0) {
                this.searchTab = 'researcher';
                this.fuzzySearch = false;
                this.setRenderedSearchState('researcher', this.getStoredAgentQuery() || this.searchText, false);
                this.agentMode = true;
                this.showEmptyGuide = false;
                this.agentSummary = '';
                await this.loadByIds(ids);
                await this.service.render();
            }
        };
        window.addEventListener('chatbot-agent-results', this.agentResultHandler);
    }

    ngOnDestroy() {
        if (this.agentResultHandler) {
            window.removeEventListener('chatbot-agent-results', this.agentResultHandler);
            this.agentResultHandler = null;
        }
        this.clearKeywordExpansionStatus();
        this.facetRequestSeq++;
        this.stopFacetLoading();
    }

    private getStoredAgentSummary(): string {
        try {
            return sessionStorage.getItem(Component.AGENT_SUMMARY_KEY) || '';
        } catch {
            return '';
        }
    }

    private getStoredAgentResearchers(): any[] {
        try {
            const raw = sessionStorage.getItem(Component.AGENT_RESEARCHERS_KEY) || '[]';
            const parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            return [];
        }
    }

    private filterStoredRowsToCurrentResults(storedRows: any[] = []): any[] {
        const visibleIds = new Set(
            (this.rows || [])
                .map((row: any) => row.researcher_id || row.id || '')
                .filter((id: string) => id)
        );
        if (!visibleIds.size) return [];
        return (storedRows || []).filter((row: any) => {
            const key = row.researcher_id || row.id || '';
            return key && visibleIds.has(key);
        });
    }

    private clearStoredAgentContext() {
        try {
            sessionStorage.removeItem(Component.AGENT_SUMMARY_KEY);
            sessionStorage.removeItem(Component.AGENT_RESEARCHERS_KEY);
            sessionStorage.removeItem(Component.AGENT_QUERY_KEY);
        } catch { }
    }

    private getStoredAgentQuery(): string {
        try {
            return sessionStorage.getItem(Component.AGENT_QUERY_KEY) || '';
        } catch {
            return '';
        }
    }

    private looksLikeRawStructuredText(text: string): boolean {
        const value = String(text || '').trim();
        if (!value) return false;
        if (value.startsWith('[') || value.startsWith('{')) return true;
        return value.includes('"researcher_id"') || value.includes('"matched_keywords"') || value.includes('"keyword_match_count"');
    }

    private async refreshAgentSummary() {
        if (!this.agentMode || !this.rows.length) {
            return;
        }

        const storedRows = this.getStoredAgentResearchers();
        const visibleStoredRows = this.filterStoredRowsToCurrentResults(storedRows);
        const query = this.getStoredAgentQuery() || this.getSearchTextForResult() || this.searchText || '';
        const targetRows = (visibleStoredRows.length > 0 ? visibleStoredRows : this.rows).slice(0, 10);

        try {
            const { code, data } = await wiz.call('generate_agent_summary', {
                message: query,
                researchers: JSON.stringify(targetRows),
            });
            if (code === 200) {
                const summary = String(data?.summary || '').trim();
                if (summary && !this.looksLikeRawStructuredText(summary)) {
                    this.agentSummary = summary;
                    try {
                        sessionStorage.setItem(Component.AGENT_SUMMARY_KEY, summary);
                    } catch { }
                    return;
                }
            }
        } catch { }

        const fallback = this.buildFallbackAgentSummary(targetRows);
        if (fallback) {
            this.agentSummary = fallback;
        }
    }

    private normalizeKeywordList(value: any): string[] {
        if (Array.isArray(value)) {
            return value.map((item: any) => String(item || '').trim()).filter((item: string) => item);
        }
        if (typeof value === 'string') {
            return value
                .split(/[;,|]/)
                .map((item: string) => item.trim())
                .filter((item: string) => item);
        }
        return [];
    }

    private toStringArray(value: any): string[] {
        return this.normalizeKeywordList(value);
    }

    private ensureFacetSelections() {
        if (!Array.isArray(this.selectedOrgs)) {
            this.selectedOrgs = this.toStringArray(this.selectedOrgs);
        }
        if (!Array.isArray(this.selectedKeywords)) {
            this.selectedKeywords = this.toStringArray(this.selectedKeywords);
        }
    }

    private normalizeKeywordTerm(value: any): string {
        return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
    }

    private uniqueKeywords(keywords: string[]): string[] {
        const seen = new Set<string>();
        return keywords
            .map((keyword: string) => String(keyword || '').trim())
            .filter((keyword: string) => {
                const key = this.normalizeKeywordTerm(keyword);
                if (!key || seen.has(key)) return false;
                seen.add(key);
                return true;
            });
    }

    private normalizeExpandedKeywords(keywords: any): string[] {
        return this.uniqueKeywords(this.normalizeKeywordList(keywords));
    }

    private mergeFacetList(apiItems: any[], rowItems: any[]): any[] {
        const merged = new Map<string, any>();

        (apiItems || []).forEach((item: any) => {
            const name = String(item?.name || '').trim();
            const key = this.normalizeKeywordTerm(name);
            if (!key) return;
            merged.set(key, { name, count: Number(item?.count || 0) || 0 });
        });

        (rowItems || []).forEach((item: any) => {
            const name = String(item?.name || '').trim();
            const key = this.normalizeKeywordTerm(name);
            if (!key) return;
            const count = Number(item?.count || 0) || 0;
            const current = merged.get(key);
            if (current) {
                current.count = Math.max(current.count, count);
            } else {
                merged.set(key, { name, count });
            }
        });

        return Array.from(merged.values())
            .sort((a: any, b: any) => b.count - a.count || a.name.localeCompare(b.name));
    }

    private normalizeFacetPayload(apiFacets: any): any {
        return {
            orgs: this.mergeFacetList(apiFacets?.orgs || [], []),
            keywords: this.mergeFacetList(apiFacets?.keywords || [], [])
        };
    }

    private canReuseExpandedKeywords(keyword: string = this.getSearchTextForResult()): boolean {
        const currentTerm = this.normalizeKeywordTerm(keyword);
        return !!currentTerm && this.expandedKeywords.some(
            (keyword: string) => this.normalizeKeywordTerm(keyword) === currentTerm
        ) && this.hasUsefulExpandedKeywords(this.expandedKeywords, currentTerm);
    }

    private hasUsefulExpandedKeywords(keywords: string[], baseTerm: string = this.normalizeKeywordTerm(this.getSearchTextForResult())): boolean {
        if (!baseTerm) return false;
        return this.uniqueKeywords(keywords || []).some(
            (keyword: string) => this.normalizeKeywordTerm(keyword) !== baseTerm
        );
    }

    private clearKeywordExpansionStatus() {
        if (this.keywordExpansionTimer) {
            clearInterval(this.keywordExpansionTimer);
            this.keywordExpansionTimer = null;
        }
        this.keywordExpansionStartedAt = 0;
        this.keywordExpansionElapsedSeconds = 0;
        this.keywordExpansionActive = false;
        this.keywordExpansionSlow = false;
        this.keywordExpansionPromptDismissed = false;
    }

    private clearKeywordExpansionModelError() {
        this.keywordExpansionModelError = '';
    }

    private clearKeywordSearchStatusError() {
        this.keywordSearchStatusErrorTitle = '';
        this.keywordSearchStatusError = '';
    }

    private setKeywordSearchStatusError(title: string, message: string, details: any = {}) {
        this.keywordSearchStatusErrorTitle = title || '키워드 검색 상태를 확인해 주세요';
        this.keywordSearchStatusError = message || '키워드 검색 결과를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.';
        const hasResponseData = Object.prototype.hasOwnProperty.call(details || {}, 'data');
        const payload = {
            source: 'page.search',
            type: details?.type || '',
            context: details?.context || '',
            title: this.keywordSearchStatusErrorTitle,
            uiMessage: this.keywordSearchStatusError,
            rawMessage: details?.rawMessage || '',
            detail: details?.detail || '',
            fallbackMessage: details?.fallbackMessage || '',
            explicitType: details?.explicitType || '',
            explicitMessage: details?.explicitMessage || '',
            combined: details?.combined || '',
            responseData: hasResponseData ? details.data : null,
            originalError: details?.originalError || null,
        };
        console.error('[KORENET] keywordSearchStatusError', payload);
        if (details?.originalError) {
            console.error('[KORENET] keywordSearchStatusError original error', details.originalError);
        }
    }

    private clearFacetSkeletonTimer() {
        if (this.facetSkeletonTimer) {
            clearTimeout(this.facetSkeletonTimer);
            this.facetSkeletonTimer = null;
        }
    }

    private clearFacetPollTimer() {
        if (this.facetPollTimer) {
            clearTimeout(this.facetPollTimer);
            this.facetPollTimer = null;
        }
    }

    private clearKeywordFacetStatusError() {
        const statusText = `${this.keywordSearchStatusErrorTitle} ${this.keywordSearchStatusError}`;
        if (statusText.includes('상세 필터')) {
            this.clearKeywordSearchStatusError();
        }
    }

    private startFacetLoading() {
        this.clearFacetSkeletonTimer();
        this.facetLoading = true;
        this.facetSkeletonVisible = this.showFilters;
        this.facetSkeletonTimer = setTimeout(async () => {
            this.facetSkeletonTimer = null;
            if (!this.facetLoading || this.facetSkeletonVisible) return;
            this.facetSkeletonVisible = true;
            await this.service.render();
        }, this.facetSkeletonDelayMs);
    }

    private stopFacetLoading() {
        this.facetLoading = false;
        this.facetSkeletonVisible = false;
        this.clearFacetSkeletonTimer();
        this.clearFacetPollTimer();
    }

    private scheduleKeywordFacetPoll(
        requestSeq: number,
        targetText: string,
        targetFuzzy: boolean,
        retryCount: number,
        serverDelay: any = 0
    ) {
        this.clearFacetPollTimer();
        const requestedDelay = Number(serverDelay || 0);
        const safeServerDelay = isNaN(requestedDelay) ? 0 : requestedDelay;
        const minimumDelay = retryCount < 10 ? 1500 : (retryCount < 60 ? 5000 : 10000);
        const retryAfter = Math.min(Math.max(safeServerDelay, minimumDelay), 15000);
        this.facetPollTimer = setTimeout(() => {
            this.facetPollTimer = null;
            if (requestSeq === this.facetRequestSeq
                && this.renderedSearchTab === 'keyword'
                && this.getRenderedSearchText() === targetText
                && this.renderedFuzzySearch === targetFuzzy) {
                this.loadKeywordFacets(retryCount + 1);
            }
        }, retryAfter);
    }

    private isAiModelProblemMessage(message: any): boolean {
        const text = String(message || '').toLowerCase();
        if (!text) return false;
        if (text.includes('keyword expansion disabled')) return false;

        const aiMarkers = [
            'llm',
            'ollama',
            'api/chat',
            'gemini',
            'openai',
            'claude',
            'chatbot',
            'model',
            '모델',
            'ai model',
            '모델 응답',
            '키워드 응답'
        ];
        const failureMarkers = [
            'not found',
            'notfound',
            'timeout',
            'timed out',
            'connection',
            'refused',
            'unavailable',
            'empty keyword response',
            'endpoint',
            'http error',
            'status code',
            'bad gateway',
            'service unavailable',
            'gateway timeout',
            '찾을 수',
            '없음',
            '타임아웃',
            '연결',
            '응답 없음',
            '500',
            '502',
            '503',
            '504'
        ];
        return aiMarkers.some((marker: string) => text.includes(marker))
            && failureMarkers.some((marker: string) => text.includes(marker));
    }

    private isMemorySearchProblemMessage(message: any): boolean {
        const text = String(message || '').toLowerCase();
        if (!text) return false;
        return [
            'memory index',
            'keyword memory',
            'keyword_memory_index',
            'search-index',
            'posting',
            'pickle',
            '메모리 검색',
            '메모리 인덱스'
        ].some((marker: string) => text.includes(marker));
    }

    private isSortProblemMessage(message: any): boolean {
        const text = String(message || '').toLowerCase();
        if (!text) return false;
        return [
            'sort',
            'order by',
            'unknown column',
            'keyword_rank_sort',
            '정렬'
        ].some((marker: string) => text.includes(marker));
    }

    private keywordStatusTitle(type: string, context: string = 'search'): string {
        if (type === 'memory_search' || type === 'memory_facets') {
            return '키워드 메모리 검색 상태를 확인해 주세요';
        }
        if (type === 'sort') return '검색 결과 정렬 상태를 확인해 주세요';
        if (type === 'facets') return '상세 필터 집계 상태를 확인해 주세요';
        if (type === 'expand') return '키워드 확장 상태를 확인해 주세요';
        return context === 'facets' ? '상세 필터 집계 상태를 확인해 주세요' : '키워드 검색 상태를 확인해 주세요';
    }

    private keywordStatusDefaultMessage(type: string, context: string = 'search'): string {
        if (type === 'memory_search') {
            return '메모리 검색 인덱스를 사용할 수 없어 결과를 불러오지 못했습니다. 관리자에게 인덱스 상태를 확인해 주세요.';
        }
        if (type === 'memory_facets') {
            return '메모리 검색 인덱스로 상세 필터를 집계하지 못했습니다. 관리자에게 인덱스 상태를 확인해 주세요.';
        }
        if (type === 'sort') {
            return '선택한 정렬 기준을 적용하지 못했습니다. 다른 정렬 기준으로 다시 시도해 주세요.';
        }
        if (type === 'facets') {
            return '상세 필터를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.';
        }
        if (type === 'expand') {
            return '키워드 확장 정보를 불러오지 못했습니다. 일반 키워드 검색으로 다시 시도해 주세요.';
        }
        return context === 'facets'
            ? '상세 필터를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.'
            : '키워드 검색 결과를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.';
    }

    private keywordSearchStatusFromResponse(data: any, fallbackMessage: any = '', context: string = 'search'): any {
        const explicitType = String(data?.keyword_status_error_type || '').trim();
        const explicitMessage = String(data?.keyword_status_error_message || '').trim();
        const fallbackText = String(fallbackMessage || '').trim();
        const rawMessage = String(
            explicitMessage
            || data?.message
            || data?.error
            || fallbackText
            || ''
        ).trim();
        const detail = String(
            data?.keyword_status_error_detail
            || data?.keyword_memory_index_error
            || data?.memory_index_error
            || ''
        ).trim();
        const combined = [
            explicitType,
            rawMessage,
            detail
        ].filter((value: any) => value !== undefined && value !== null).join(' ');

        let type = explicitType;
        if (!type && this.isMemorySearchProblemMessage(combined)) {
            type = context === 'facets' ? 'memory_facets' : 'memory_search';
        } else if (!type && this.isSortProblemMessage(combined)) {
            type = 'sort';
        } else if (!type && context === 'facets' && (rawMessage || detail)) {
            type = 'facets';
        } else if (!type && context === 'expand' && (rawMessage || detail)) {
            type = 'expand';
        } else if (!type && rawMessage) {
            type = 'search';
        }

        if (!type) return null;

        const message = explicitMessage || this.keywordStatusDefaultMessage(type, context);
        return {
            title: this.keywordStatusTitle(type, context),
            message,
            type,
            context,
            rawMessage,
            detail,
            fallbackMessage: fallbackText,
            explicitType,
            explicitMessage,
            combined,
            data,
        };
    }

    private keywordExpansionErrorFromResponse(data: any): string {
        const message = String(data?.keyword_expansion_error || data?.model_error_message || '').trim();
        if (message) return message;
        if (data?.model_error === true) return this.keywordExpansionModelNotice;
        return '';
    }

    private keywordSearchLoadingMessage(keyword: string): string {
        const label = String(keyword || '').trim() || '입력한 키워드';
        return `'${label}'에 대한 관련 연구자를 집계중입니다. 잠시만 기다려주세요.`;
    }

    private setKeywordExpansionMessage(message: string) {
        this.keywordExpansionMessage = String(message || '').trim()
            || 'AI 키워드 확장 후 연구자 집계중입니다. 잠시만 기다려주세요.';
        this.keywordExpansionMessageChars = Array.from(this.keywordExpansionMessage).map((char: string, index: number) => ({
            char,
            isSpace: char === ' ',
            delay: `${index * 0.045}s`
        }));
    }

    private startKeywordExpansionStatus(message: string = this.keywordExpansionMessage) {
        this.clearKeywordExpansionStatus();
        this.setKeywordExpansionMessage(message);
        this.keywordExpansionActive = true;
        this.keywordExpansionStartedAt = Date.now();
        this.keywordExpansionTimer = setInterval(async () => {
            if (!this.keywordExpansionActive) return;
            this.keywordExpansionElapsedSeconds = Math.floor((Date.now() - this.keywordExpansionStartedAt) / 1000);
            if (this.keywordExpansionElapsedSeconds >= 30 && !this.keywordExpansionPromptDismissed) {
                this.keywordExpansionSlow = true;
            }
            await this.service.render();
        }, 1000);
    }

    public async continueKeywordExpansionWait() {
        this.keywordExpansionPromptDismissed = true;
        this.keywordExpansionSlow = false;
        await this.service.render();
    }

    public async useExactKeywordSearch() {
        if (!this.getRenderedSearchText()) return;
        const requestSeq = ++this.keywordSearchRequestSeq;
        this.clearKeywordExpansionStatus();
        this.clearKeywordExpansionModelError();
        this.clearKeywordSearchStatusError();
        if (this.searchTab === 'keyword') {
            this.fuzzySearch = false;
        }
        this.renderedFuzzySearch = false;
        this.expandedKeywords = [];
        this.showAllExpandedKeywords = false;
        this.page = 1;
        await this.service.render();
        const keywordLoaded = await this.loadByKeyword(1, { requestSeq, forceExact: true });
        if (keywordLoaded) {
            this.loadKeywordFacets();
        }
    }

    private getRawMatchedKeywords(row: any): string[] {
        return this.normalizeKeywordList(row?.matched_keywords);
    }

    private getPrimaryMatchedKeywords(row: any): string[] {
        return this.normalizeKeywordList(row?.primary_matched_keywords);
    }

    private preferSourceKeywordLabels(row: any, keywords: string[]): string[] {
        const sourceLabels = [
            ...this.normalizeKeywordList(row?.keyword_kor),
            ...this.normalizeKeywordList(row?.keyword_eng)
        ];
        const exactSourceLabels = new Set<string>(sourceLabels);
        const sourceLabelByKey = new Map<string, string>();
        sourceLabels.forEach((label: string) => {
            const key = this.normalizeKeywordTerm(label);
            if (key && !sourceLabelByKey.has(key)) sourceLabelByKey.set(key, label);
        });
        return this.uniqueKeywords((keywords || []).map((keyword: string) => {
            const label = String(keyword || '').trim();
            if (exactSourceLabels.has(label)) return label;
            return sourceLabelByKey.get(this.normalizeKeywordTerm(label)) || label;
        }));
    }

    private getKeywordFocusTerms(row: any): string[] {
        const keywords: string[] = [];
        const searchKeyword = row?._rendered_search_keyword || this.getSearchTextForResult();

        if (this.isKeywordResultMode()) {
            keywords.push(...this.getPrimaryMatchedKeywords(row));
            keywords.push(...this.getRawMatchedKeywords(row));
            if (searchKeyword) keywords.push(searchKeyword);
            keywords.push(...this.selectedKeywords);
            return this.uniqueKeywords(keywords);
        }

        keywords.push(...this.getRawMatchedKeywords(row));
        keywords.push(...this.selectedKeywords);
        if (searchKeyword) {
            keywords.push(searchKeyword);
        }
        return this.uniqueKeywords(keywords).slice(0, 20);
    }

    private getKeywordFocusMatch(tag: string, row: any): any {
        const tagKey = this.normalizeKeywordTerm(tag);
        const fallback = { priority: 3, index: 999999 };
        if (!tagKey) return fallback;

        const focusTerms = this.getKeywordFocusTerms(row);
        if (focusTerms.length === 0) return fallback;

        for (let i = 0; i < focusTerms.length; i++) {
            if (tagKey === this.normalizeKeywordTerm(focusTerms[i])) {
                return { priority: 0, index: i };
            }
        }
        for (let i = 0; i < focusTerms.length; i++) {
            const keywordKey = this.normalizeKeywordTerm(focusTerms[i]);
            if (keywordKey && tagKey.includes(keywordKey)) {
                return { priority: 1, index: i };
            }
        }
        for (let i = 0; i < focusTerms.length; i++) {
            const keywordKey = this.normalizeKeywordTerm(focusTerms[i]);
            if (tagKey.length >= 2 && keywordKey.includes(tagKey)) {
                return { priority: 2, index: i };
            }
        }
        return fallback;
    }

    private getDetailMatchedKeywordTags(row: any): string[] {
        const tags = this._getAllTags(row);
        if (tags.length === 0) return [];

        return tags
            .map((tag: string, index: number) => ({
                tag,
                index,
                match: this.getKeywordFocusMatch(tag, row)
            }))
            .filter((item: any) => item.match.priority < 3)
            .sort((a: any, b: any) => {
                if (a.match.priority !== b.match.priority) return a.match.priority - b.match.priority;
                if (a.match.index !== b.match.index) return a.match.index - b.match.index;
                return a.index - b.index;
            })
            .map((item: any) => item.tag);
    }

    private getKeywordSearchMatchedKeywords(row: any, detailKeywords: string[] = this.getDetailMatchedKeywordTags(row)): string[] {
        const rawKeywords = this.getRawMatchedKeywords(row);
        // 같은 키워드의 대소문자가 다르면 연구자 원본 키워드 컬럼의 표기를 우선한다.
        const sourceMatchedKeywords = this.preferSourceKeywordLabels(row, rawKeywords);
        const combinedKeywords = this.uniqueKeywords([...sourceMatchedKeywords, ...detailKeywords]);
        if (combinedKeywords.length > 0) return combinedKeywords;
        return this.preferSourceKeywordLabels(row, this.getPrimaryMatchedKeywords(row));
    }

    private freezeRenderedMatchedKeywords(rows: any[], searchKeyword: string = this.getSearchTextForResult()) {
        (rows || []).forEach((row: any) => {
            if (!row) return;
            row._rendered_search_keyword = String(searchKeyword || '').trim();
            const detailKeywords = this.getDetailMatchedKeywordTags(row);
            if (this.isKeywordResultMode()) {
                row._rendered_matched_keywords = this.getKeywordSearchMatchedKeywords(row, detailKeywords);
                return;
            }
            row._rendered_matched_keywords = detailKeywords.length > 0
                ? this.uniqueKeywords(detailKeywords).slice(0, 20)
                : this.getRawMatchedKeywords(row).slice(0, 20);
        });
    }

    public getMatchedKeywords(row: any): string[] {
        if (Array.isArray(row?._rendered_matched_keywords)) {
            return this.preferSourceKeywordLabels(row, row._rendered_matched_keywords);
        }
        const detailKeywords = this.getDetailMatchedKeywordTags(row);
        if (this.isKeywordResultMode()) return this.getKeywordSearchMatchedKeywords(row, detailKeywords);
        if (detailKeywords.length > 0) return this.uniqueKeywords(detailKeywords).slice(0, 20);
        return this.getRawMatchedKeywords(row).slice(0, 20);
    }

    public getMatchedKeywordPreviewCandidates(row: any): string[] {
        return this.getMatchedKeywords(row).slice(0, this.matchedKeywordPreviewCandidateLimit);
    }

    public hasMatchedKeywordMore(row: any): boolean {
        return this.getMatchedKeywords(row).length > this.matchedKeywordMoreThreshold;
    }

    public async openMatchedKeywordModal(row: any, event?: Event) {
        if (event) event.stopPropagation();
        this.popoverCardId = '';
        this.matchedKeywordModalRow = row;
        await this.service.render();
    }

    public async closeMatchedKeywordModal(event?: Event) {
        if (event) event.stopPropagation();
        this.matchedKeywordModalRow = null;
        await this.service.render();
    }

    private getResearcherDetailKeywords(row: any): string[] {
        const keywords: string[] = [];
        const searchKeyword = row?._rendered_search_keyword || this.getSearchTextForResult();

        if (this.isKeywordResultMode()) {
            keywords.push(...this.getPrimaryMatchedKeywords(row));
            if (searchKeyword) keywords.push(searchKeyword);
            keywords.push(...this.selectedKeywords);
            return this.uniqueKeywords(keywords).slice(0, 20);
        }

        const matchedKeywords = this.getMatchedKeywords(row);
        if (matchedKeywords.length === 0 && searchKeyword) {
            keywords.push(searchKeyword);
        }
        keywords.push(...matchedKeywords);
        keywords.push(...this.selectedKeywords);

        return this.uniqueKeywords(keywords).slice(0, 20);
    }

    private buildResearcherDetailUrl(id: string, row: any): string {
        const keywords = this.getResearcherDetailKeywords(row);
        if (keywords.length === 0) return `/researcher/${id}`;

        const params = new URLSearchParams();
        params.set('keywords', keywords.join('|'));
        return `/researcher/${id}?${params.toString()}`;
    }

    public getMatchedKeywordCount(row: any): number {
        const displayCount = this.getMatchedKeywords(row).length;
        if (displayCount > 0) return displayCount;
        if (this.isKeywordResultMode() && this.hasPrimaryKeywordMetrics(row)) {
            return this.toCount(row?.primary_keyword_match_count);
        }
        return this.toCount(row?.keyword_match_count);
    }

    private toCount(value: any): number {
        const count = Number(value || 0);
        return Number.isFinite(count) ? count : 0;
    }

    private hasPrimaryKeywordMetrics(row: any): boolean {
        if (!row) return false;
        return this.toCount(row?.primary_keyword_pub_count) > 0
            || this.toCount(row?.primary_keyword_paper_count) > 0
            || this.toCount(row?.primary_keyword_patent_count) > 0
            || this.toCount(row?.primary_keyword_report_count) > 0;
    }

    public getKeywordPublicationCount(row: any): number {
        if (this.isKeywordResultMode() && this.hasPrimaryKeywordMetrics(row)) {
            const primaryCount = this.toCount(row?.primary_keyword_pub_count);
            if (primaryCount > 0) return primaryCount;
            return this.toCount(row?.primary_keyword_paper_count)
                + this.toCount(row?.primary_keyword_patent_count)
                + this.toCount(row?.primary_keyword_report_count);
        }
        const explicitCount = this.toCount(row?.keyword_pub_count);
        if (explicitCount > 0) return explicitCount;
        return this.getKeywordPaperCount(row) + this.getKeywordPatentCount(row) + this.getKeywordReportCount(row);
    }

    public getKeywordPaperCount(row: any): number {
        if (this.isKeywordResultMode() && this.hasPrimaryKeywordMetrics(row)) {
            return this.toCount(row?.primary_keyword_paper_count);
        }
        return this.toCount(row?.keyword_paper_count);
    }

    public getKeywordPatentCount(row: any): number {
        if (this.isKeywordResultMode() && this.hasPrimaryKeywordMetrics(row)) {
            return this.toCount(row?.primary_keyword_patent_count);
        }
        return this.toCount(row?.keyword_patent_count);
    }

    public getKeywordReportCount(row: any): number {
        if (this.isKeywordResultMode() && this.hasPrimaryKeywordMetrics(row)) {
            return this.toCount(row?.primary_keyword_report_count);
        }
        return this.toCount(row?.keyword_report_count);
    }

    public getRecommendationReason(row: any): string {
        if (!row) return '';

        const reasons: string[] = [];
        const primaryMetricMode = this.isKeywordResultMode() && this.hasPrimaryKeywordMetrics(row);
        const directMatchedKeywords = this.getPrimaryMatchedKeywords(row);
        const matchedKeywords = (
            primaryMetricMode
                ? directMatchedKeywords
                : this.normalizeKeywordList(row.matched_keywords)
        ).slice(0, 3);
        const sharedKeywords = this.normalizeKeywordList(row.shared_keywords).slice(0, 3);
        const keywordPreview = this.normalizeKeywordList(row.keyword_kor || row.keyword).slice(0, 3);

        const keywordPubCount = primaryMetricMode
            ? Number(row.primary_keyword_pub_count || 0)
            : Number(row.keyword_pub_count || 0);
        const keywordMatchCount = primaryMetricMode
            ? Number(row.primary_keyword_match_count || matchedKeywords.length || 0)
            : Number(row.keyword_match_count || matchedKeywords.length || 0);
        const paperCount = Number(row.paper_cnt || 0);
        const reportCount = Number(row.report_cnt || 0);
        const patentCount = Number(row.patent_cnt || 0);
        const coauthorPaperCount = Number(row.coauthor_paper_count || 0);
        const similarityScore = Number(row.similarity_score || 0);

        if (matchedKeywords.length > 0) {
            const keywordText = matchedKeywords.join(', ');
            if (keywordPubCount > 0) {
                reasons.push(`${keywordText} 관련 성과가 ${keywordPubCount}건 확인돼 질문 키워드와 직접 연결됩니다.`);
            } else {
                reasons.push(`${keywordText} 등 ${keywordMatchCount}개 핵심 키워드가 질문 주제와 맞닿아 있습니다.`);
            }
        } else if (sharedKeywords.length > 0) {
            const sharedText = sharedKeywords.join(', ');
            if (coauthorPaperCount > 0) {
                reasons.push(`${sharedText} 주제가 겹치고 공동 연구 ${coauthorPaperCount}건이 있어 연관성이 높습니다.`);
            } else {
                const scoreText = similarityScore > 0 ? similarityScore.toFixed(2).replace(/\.00$/, '') : '상당';
                reasons.push(`${sharedText} 주제가 겹치며 유사도 ${scoreText} 수준의 가까운 연구 흐름을 보입니다.`);
            }
        }

        if (paperCount > 0) {
            reasons.push(`관련 분야 논문 ${paperCount}편을 보유해 후속 검토 가치가 높습니다.`);
        } else if (reportCount > 0 || patentCount > 0) {
            const outputs = [];
            if (reportCount > 0) outputs.push(`보고서 ${reportCount}건`);
            if (patentCount > 0) outputs.push(`특허 ${patentCount}건`);
            reasons.push(`${outputs.join(', ')}을 보유한 실무형 연구 이력이 확인됩니다.`);
        } else if (keywordPreview.length > 0) {
            reasons.push(`${keywordPreview.join(', ')} 중심으로 연구를 이어 온 전문가입니다.`);
        }

        return reasons.slice(0, 2).join(' ');
    }

    private buildFallbackAgentSummary(rows: any[]): string {
        const sourceRows = rows || [];
        if (sourceRows.length === 0) return '';

        const keywordCounts = new Map<string, number>();
        let hasDirectMatch = false;
        let hasSimilarity = false;
        let hasNetwork = false;

        for (const row of sourceRows) {
            const matchedKeywords = this.normalizeKeywordList(row?.matched_keywords);
            const sharedKeywords = this.normalizeKeywordList(row?.shared_keywords);
            const previewKeywords = this.normalizeKeywordList(row?.keyword || row?.keyword_kor).slice(0, 2);
            const uniqueKeywords = new Set<string>([...matchedKeywords, ...sharedKeywords, ...previewKeywords]);

            if (matchedKeywords.length > 0 || Number(row?.keyword_pub_count || 0) > 0) {
                hasDirectMatch = true;
            }
            if (sharedKeywords.length > 0 || Number(row?.similarity_score || 0) > 0) {
                hasSimilarity = true;
            }
            if (Number(row?.coauthor_paper_count || 0) > 0) {
                hasNetwork = true;
            }

            uniqueKeywords.forEach((keyword: string) => {
                const normalized = String(keyword || '').trim();
                if (!normalized) return;
                keywordCounts.set(normalized, (keywordCounts.get(normalized) || 0) + 1);
            });
        }

        const topKeywords = Array.from(keywordCounts.entries())
            .sort((left, right) => {
                if (right[1] !== left[1]) return right[1] - left[1];
                return left[0].localeCompare(right[0], 'ko');
            })
            .slice(0, 3)
            .map(([keyword]) => keyword);

        const overview = topKeywords.length > 0
            ? `추천된 연구자들은 ${topKeywords.join(', ')}을 중심으로 질문 주제와 맞닿은 연구 경험을 보여 함께 추천되었습니다.`
            : '추천된 연구자들은 질문 주제와 맞닿은 연구 경험과 전문성을 공통으로 보여 함께 추천되었습니다.';

        const evidence = hasDirectMatch && (hasSimilarity || hasNetwork)
            ? '직접적인 주제 적합성에 더해 유사한 연구 흐름과 협업 맥락도 함께 확인돼, 한 방향이 아니라 여러 근거에서 검토 가치가 높은 후보들입니다.'
            : hasDirectMatch
                ? '관련 성과와 연구 키워드에서 공통성이 확인돼 우선 검토할 후보군으로 정리했습니다.'
                : hasSimilarity || hasNetwork
                    ? '세부 주제의 연결성과 연구 흐름의 유사성이 확인돼 함께 검토할 가치가 있는 후보들입니다.'
                    : '질문과 연결되는 연구 배경과 전문 주제가 겹쳐 종합 추천 대상으로 정리했습니다.';

        return `${overview} ${evidence}`.trim();
    }

    public getAgentSummaryText(): string {
        if (!this.agentMode) return '';

        if (this.agentSummary && !this.looksLikeRawStructuredText(this.agentSummary)) {
            return this.agentSummary;
        }

        const storedRows = this.getStoredAgentResearchers();
        const visibleStoredRows = this.filterStoredRowsToCurrentResults(storedRows);
        return this.buildFallbackAgentSummary(visibleStoredRows.length > 0 ? visibleStoredRows : this.rows);
    }

    private scoreComponentMeta(): any[] {
        return [
            { key: 'paper', weightKey: 'paper_count_weight', label: '논문 수' },
            { key: 'report', weightKey: 'report_count_weight', label: '보고서 수' },
            { key: 'recency', weightKey: 'recent_count_weight', label: '최근 3년' },
            { key: 'patent', weightKey: 'patent_count_weight', label: '특허 수' },
            { key: 'focus', weightKey: 'focus_score_weight', label: '집중도' },
            { key: 'publication', weightKey: 'publication_score_weight', label: '성과물 점수' },
            { key: 'journal_level', weightKey: 'journal_level_score_weight', label: '학술지 수준' },
        ];
    }

    private numberValue(value: any, fallback: number = 0): number {
        const number = Number(value);
        return Number.isFinite(number) ? number : fallback;
    }

    private getScoreBreakdown(row: any): any {
        return row?.score_breakdown || {};
    }

    private getScoreWeights(row: any): any {
        const breakdown = this.getScoreBreakdown(row);
        return breakdown.weights_applied || row?.weights_applied || {};
    }

    private getNormalizedComponents(row: any): any {
        const breakdown = this.getScoreBreakdown(row);
        return breakdown.normalized_score_components || row?.normalized_score_components || {};
    }

    public formatScore(value: any): string {
        const number = Number(value);
        if (!Number.isFinite(number)) return '0';
        if (Math.abs(number) >= 100) return number.toFixed(0);
        if (Math.abs(number) >= 10) return number.toFixed(2).replace(/\.?0+$/, '');
        return number.toFixed(4).replace(/\.?0+$/, '');
    }

    public hasScoreEvidence(row: any): boolean {
        if (!this.agentMode || !row) return false;
        const breakdown = this.getScoreBreakdown(row);
        const hasScore = row.score !== undefined && row.score !== null && Number(row.score) > 0;
        const hasWeighted = row.weighted_score !== undefined && row.weighted_score !== null && Number(row.weighted_score) > 0;
        const hasComponents = Object.keys(this.getNormalizedComponents(row)).length > 0
            || Object.keys(row.score_components || {}).length > 0
            || Object.keys(breakdown.score_components || {}).length > 0;
        return hasScore || hasWeighted || hasComponents;
    }

    public hasAgentEvidence(): boolean {
        return this.agentMode && (this.rows || []).some((row: any) => this.hasScoreEvidence(row));
    }

    public getAgentEvidenceRows(): any[] {
        return (this.rows || []).filter((row: any) => this.hasScoreEvidence(row)).slice(0, 5);
    }

    public getAppliedWeightChips(row: any = null): any[] {
        const target = row || this.getAgentEvidenceRows()[0];
        if (!target) return [];
        const weights = this.getScoreWeights(target);
        return this.scoreComponentMeta()
            .map((meta: any) => ({
                label: meta.label,
                value: this.numberValue(weights[meta.weightKey], NaN)
            }))
            .filter((item: any) => Number.isFinite(item.value))
            .map((item: any) => ({
                label: item.label,
                text: `${Math.round(item.value * 100)}%`
            }));
    }

    public getAgentMatchedKeywordPreview(): string[] {
        const seen = new Set<string>();
        const keywords: string[] = [];
        (this.rows || []).forEach((row: any) => {
            this.getMatchedKeywords(row).forEach((keyword: string) => {
                const key = this.normalizeKeywordTerm(keyword);
                if (!key || seen.has(key)) return;
                seen.add(key);
                keywords.push(keyword);
            });
        });
        return keywords.slice(0, 12);
    }

    public getScoreFormula(row: any): string {
        if (!this.hasScoreEvidence(row)) return '';
        const breakdown = this.getScoreBreakdown(row);
        const finalScore = this.numberValue(row?.score, this.numberValue(breakdown.score, 0));
        const weightedScore = this.numberValue(row?.weighted_score, this.numberValue(breakdown.weighted_score, 0));
        const keywordWeight = this.numberValue(row?.keyword_weight, this.numberValue(breakdown.keyword_weight, 1));
        const keywordPublicationScore = this.numberValue(
            row?.keyword_publication_score,
            this.numberValue(breakdown.keyword_publication_score, 0)
        );

        if (finalScore > 0 && weightedScore > 0) {
            return `최종점수 ${this.formatScore(finalScore)} = 사용자 가중점수 ${this.formatScore(weightedScore)} × 키워드 동시매칭 ${this.formatScore(keywordWeight)}`;
        }
        if (finalScore > 0 && keywordPublicationScore > 0) {
            return `최종점수 ${this.formatScore(finalScore)} = 키워드 성과점수 ${this.formatScore(keywordPublicationScore)} × 키워드 동시매칭 ${this.formatScore(keywordWeight)}`;
        }
        return '';
    }

    public getAgentSortBasisText(): string {
        if (!this.hasAgentEvidence()) {
            return '현재 목록은 AI 에이전트가 전달한 추천 순서를 유지합니다.';
        }
        return '정렬은 최종점수가 높은 순서를 기준으로 하며, 최종점수는 사용자 가중점수에 키워드 동시매칭 가중치를 곱해 계산합니다.';
    }

    public getScoreComponentRows(row: any): any[] {
        if (!this.hasScoreEvidence(row)) return [];
        const weights = this.getScoreWeights(row);
        const normalized = this.getNormalizedComponents(row);
        return this.scoreComponentMeta()
            .map((meta: any) => {
                const weight = this.numberValue(weights[meta.weightKey], NaN);
                const relative = this.numberValue(normalized[meta.key], 0);
                const contribution = Number.isFinite(weight) ? weight * relative : 0;
                return {
                    label: meta.label,
                    weight,
                    relative,
                    contribution,
                    weightText: Number.isFinite(weight) ? `${Math.round(weight * 100)}%` : '-',
                    relativeText: this.formatScore(relative),
                    contributionText: this.formatScore(contribution),
                };
            })
            .filter((item: any) => Number.isFinite(item.weight) || item.relative > 0 || item.contribution > 0);
    }

    public getScoreEvidenceText(row: any): string {
        const keywords = this.getMatchedKeywords(row).slice(0, 5);
        const keywordText = keywords.length > 0 ? `매칭 키워드 ${keywords.join(', ')}` : '';
        const formula = this.getScoreFormula(row);
        return [formula, keywordText].filter((part: string) => part).join(' · ');
    }

    private mergeAgentRows(rows: any[], orderedIds: string[] = []): any[] {
        const storedRows = this.getStoredAgentResearchers();
        const lookup = new Map<string, any>();
        const order = new Map<string, number>();

        orderedIds.forEach((id: string, index: number) => {
            if (id) order.set(id, index);
        });

        storedRows.forEach((row: any, index: number) => {
            const key = row.researcher_id || row.id || '';
            if (!key) return;
            lookup.set(key, row);
            if (!order.has(key)) {
                order.set(key, index);
            }
        });

        const merged = (rows || []).map((row: any) => {
            const key = row.researcher_id || row.id || '';
            const saved = key ? (lookup.get(key) || {}) : {};
            const combined = { ...saved, ...row };
            combined.ai_recommended = true;
            combined.recommendation_reason = this.getRecommendationReason(combined);
            return combined;
        });

        if (order.size > 0) {
            merged.sort((left: any, right: any) => {
                const leftKey = left.researcher_id || left.id || '';
                const rightKey = right.researcher_id || right.id || '';
                const leftOrder = order.has(leftKey) ? (order.get(leftKey) as number) : Number.MAX_SAFE_INTEGER;
                const rightOrder = order.has(rightKey) ? (order.get(rightKey) as number) : Number.MAX_SAFE_INTEGER;
                return leftOrder - rightOrder;
            });
        }

        return merged;
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: Event) {
        let shouldRender = false;
        if (this.searchTabDropdownOpen) {
            this.searchTabDropdownOpen = false;
            shouldRender = true;
        }
        if (this.popoverCardId) {
            this.popoverCardId = '';
            shouldRender = true;
        }
        if (this.showFacetPanel || this.openFacetCategory) {
            this.showFacetPanel = false;
            this.openFacetCategory = '';
            shouldRender = true;
        }
        if (shouldRender) {
            this.service.render();
        }
    }

    private updateUrlParams() {
        const params = new URLSearchParams();
        const resultTab = this.normalizeSearchTab(this.renderedSearchTab);
        const resultText = this.getRenderedSearchText();
        const normalizedFuzzy = this.normalizeFuzzy(resultTab, this.renderedFuzzySearch);
        this.renderedFuzzySearch = normalizedFuzzy;
        if (resultText) params.set('q', resultText);
        if (resultTab !== 'researcher') params.set('tab', resultTab);
        if (this.sort !== this.getDefaultSort(resultTab)) params.set('sort', this.sort);
        if (normalizedFuzzy !== this.getDefaultFuzzy(resultTab)) {
            params.set('fuzzy', normalizedFuzzy ? 'true' : 'false');
        }
        if (this.page > 1) params.set('page', String(this.page));
        const qs = params.toString();
        const url = '/search' + (qs ? '?' + qs : '');
        history.replaceState(null, '', url);
    }

    public openResearcherDiscoveryPage() {
        const params = new URLSearchParams();
        const keyword = this.getRenderedSearchText();
        const expandedKeywords = this.renderedFuzzySearch
            ? this.normalizeExpandedKeywords(this.expandedKeywords)
            : [];
        const canShareExpandedKeywords = expandedKeywords.length > 1
            && this.hasUsefulExpandedKeywords(
                expandedKeywords,
                this.normalizeKeywordTerm(expandedKeywords[0] || keyword)
            );
        const discoveryKeyword = canShareExpandedKeywords ? expandedKeywords[0] : keyword;
        if (discoveryKeyword) params.set('q', discoveryKeyword);
        if (canShareExpandedKeywords) {
            params.set('expanded_keywords', JSON.stringify(expandedKeywords));
        }
        const qs = params.toString();
        const discoveryUrl = '/researcher-discovery' + (qs ? '?' + qs : '');
        window.open(discoveryUrl, '_blank', 'noopener,noreferrer');
    }

    // ── 패싯 네비게이터 ──

    public async loadFacets() {
        const targetText = this.getRenderedSearchText();
        if (!targetText || this.renderedSearchTab !== 'researcher') {
            this.stopFacetLoading();
            return;
        }
        const requestSeq = ++this.facetRequestSeq;
        const targetFuzzy = false;
        this.renderedFuzzySearch = false;
        this.startFacetLoading();
        this.showAllOrgs = false;
        this.keywordsLimit = 30;
        try {
            const { code, data } = await wiz.call("facets", {
                text: targetText,
                fuzzy: targetFuzzy ? 'true' : 'false'
            });
            if (code === 200 && requestSeq === this.facetRequestSeq
                && this.renderedSearchTab === 'researcher'
                && this.getRenderedSearchText() === targetText
                && this.renderedFuzzySearch === targetFuzzy) {
                this.facets = this.normalizeFacetPayload({
                    orgs: data.orgs || [],
                    keywords: data.keywords || []
                });
            }
        } catch (e) { }
        if (requestSeq === this.facetRequestSeq) {
            this.stopFacetLoading();
            await this.service.render();
        }
    }

    public isOrgSelected(orgName: string): boolean {
        this.ensureFacetSelections();
        return this.selectedOrgs.includes(orgName);
    }

    public isKeywordSelected(keyword: string): boolean {
        this.ensureFacetSelections();
        return this.selectedKeywords.includes(keyword);
    }

    public async toggleFacetOrg(orgName: string) {
        this.ensureFacetSelections();
        const idx = this.selectedOrgs.indexOf(orgName);
        if (idx >= 0) {
            this.selectedOrgs.splice(idx, 1);
        } else {
            this.selectedOrgs.push(orgName);
        }
        this.page = 1;
        if (this.isKeywordResultMode()) {
            await this.loadByKeyword(1, {
                reuseResultCache: true,
                showKeywordLoadingCard: false
            });
        } else {
            await this.load(1, { showResearcherLoadingCard: false });
        }
    }

    public async toggleFacetKeyword(keyword: string) {
        this.ensureFacetSelections();
        const idx = this.selectedKeywords.indexOf(keyword);
        if (idx >= 0) {
            this.selectedKeywords.splice(idx, 1);
        } else {
            this.selectedKeywords.push(keyword);
        }
        this.page = 1;
        if (this.isKeywordResultMode()) {
            await this.loadByKeyword(1, {
                reuseResultCache: true,
                showKeywordLoadingCard: false
            });
        } else {
            await this.load(1, { showResearcherLoadingCard: false });
        }
    }

    public async clearFacets() {
        this.selectedOrgs = [];
        this.selectedKeywords = [];
        this.page = 1;
        if (this.isKeywordResultMode()) {
            await this.loadByKeyword(1, {
                reuseResultCache: true,
                showKeywordLoadingCard: false
            });
        } else {
            await this.load(1, { showResearcherLoadingCard: false });
        }
    }

    public async toggleFacetPanel(event: Event) {
        event.stopPropagation();
        this.showFacetPanel = !this.showFacetPanel;
        await this.service.render();
    }

    public async toggleFacetCategory(event: Event, category: string) {
        event.stopPropagation();
        this.openFacetCategory = this.openFacetCategory === category ? '' : category;
        await this.service.render();
    }

    public get hasFacetFilters(): boolean {
        this.ensureFacetSelections();
        return this.selectedOrgs.length > 0 || this.selectedKeywords.length > 0;
    }

    public get hasFacetData(): boolean {
        return this.facets.orgs.length > 0 || this.facets.keywords.length > 0;
    }

    public get visibleOrgs(): any[] {
        return this.showAllOrgs ? this.facets.orgs : this.facets.orgs.slice(0, 10);
    }

    public get visibleKeywords(): any[] {
        return this.facets.keywords.slice(0, this.keywordsLimit);
    }

    public get hasMoreKeywords(): boolean {
        return this.facets.keywords.length > this.keywordsLimit;
    }

    public get visibleExpandedKeywords(): string[] {
        return this.showAllExpandedKeywords
            ? this.expandedKeywords
            : this.expandedKeywords.slice(0, this.expandedKeywordCollapsedPreviewCount);
    }

    public get hasHiddenExpandedKeywords(): boolean {
        return !this.showAllExpandedKeywords && this.expandedKeywords.length > this.visibleExpandedKeywords.length;
    }

    public async toggleShowAllOrgs() {
        this.showAllOrgs = !this.showAllOrgs;
        await this.service.render();
    }

    public async showMoreKeywords() {
        this.keywordsLimit += 30;
        await this.service.render();
    }

    public async collapseKeywords() {
        this.keywordsLimit = 30;
        await this.service.render();
    }

    public async toggleExpandedKeywords() {
        this.showAllExpandedKeywords = !this.showAllExpandedKeywords;
        await this.service.render();
    }

    // ── 검색/로딩 ──

    public async loadByIds(ids: string[]) {
        this.keywordSearchRequestSeq++;
        this.clearKeywordExpansionStatus();
        this.clearKeywordExpansionModelError();
        this.clearKeywordSearchStatusError();
        this.loading = true;
        this.agentMode = true;
        this.setRenderedSearchState('researcher', this.getStoredAgentQuery() || this.searchText, false);
        this.agentSummary = '';
        await this.service.render();

        const { code, data } = await wiz.call("search_by_ids", {
            ids: ids.join(',')
        });

        if (code === 200) {
            this.rows = this.mergeAgentRows(data.rows || [], ids);
            this.total = data.total || this.rows.length;
            this.lastPage = 1;
            this.page = 1;
            await this.refreshAgentSummary();
        }
        this.loading = false;
        await this.service.render();
    }

    public async clearAgentMode() {
        this.agentMode = false;
        this.agentSummary = '';
        this.rows = [];
        this.total = 0;
        this.clearStoredAgentContext();
        this.updateUrlParams();
        await this.load();
        await this.loadFacets();
    }

    public async load(page: number = this.page, options: any = {}) {
        this.keywordSearchRequestSeq++;
        this.clearKeywordExpansionStatus();
        this.clearKeywordExpansionModelError();
        this.clearKeywordSearchStatusError();
        const targetText = String(options.searchText !== undefined ? options.searchText : this.getSearchTextForResult()).trim();
        const targetFuzzy = false;
        this.setRenderedSearchState('researcher', targetText, targetFuzzy);
        this.researcherLoadingMessage = targetText
            ? `'${targetText}' 연구자 목록을 메모리에서 가져오는 중입니다.`
            : '메모리에서 연구자 목록을 가져오는 중입니다.';
        this.researcherLoadingCardVisible = options.showResearcherLoadingCard !== false;
        this.loading = true;
        this.page = page;
        this.agentMode = false;
        this.sort = this.normalizeSort(this.sort, this.renderedSearchTab);
        await this.service.render();

        const params: any = {
            text: targetText,
            search_type: 'name',
            page: this.page,
            dump: this.dump,
            sort: this.sort,
            order: this.order,
            fuzzy: targetFuzzy ? 'true' : 'false',
            cache_token: this.ensureKeywordResultCacheToken(),
            cache_reset: options.resetCache === true ? 'true' : 'false'
        };

        // 패싯 필터 적용
        if (this.selectedOrgs.length > 0) {
            params.facet_orgs = this.selectedOrgs.join('|');
        }
        if (this.selectedKeywords.length > 0) {
            params.facet_keywords = this.selectedKeywords.join('|');
        }

        const { code, data } = await wiz.call("search", params);

        if (code === 200) {
            this.rows = data.rows;
            this.total = data.total;
            this.lastPage = Math.ceil(this.total / this.dump) || 1;
        }
        this.loading = false;
        this.updateUrlParams();
        await this.service.render();
    }

    public async loadByKeyword(page: number = this.page, options: any = {}) {
        const requestSeq = options.requestSeq || ++this.keywordSearchRequestSeq;
        const targetKeyword = String(options.searchText !== undefined ? options.searchText : this.getSearchTextForResult()).trim();
        const sourceFuzzy = options.searchText !== undefined ? this.fuzzySearch : this.renderedFuzzySearch;
        const targetFuzzy = this.normalizeFuzzy('keyword', options.forceExact ? false : sourceFuzzy);
        this.setRenderedSearchState('keyword', targetKeyword, targetFuzzy);
        this.loading = true;
        this.page = page;
        this.agentMode = false;
        this.sort = this.normalizeSort(this.sort, this.renderedSearchTab);
        this.clearKeywordExpansionModelError();
        this.clearKeywordSearchStatusError();
        let keywordExpansionError = '';
        let keywordStatusError: any = null;
        let requestPhase = 'keyword_search';
        let searchSucceeded = false;
        const reuseResultCache = options.reuseResultCache === true;
        let reusableExpandedKeywords: string[] = [];
        let hasReusableExpandedKeywords = false;
        let shouldRequestKeywordExpansion = false;
        const shouldShowKeywordLoadingCard = options.showKeywordLoadingCard !== false;
        const keywordLoadingMessage = targetFuzzy
            ? 'AI 키워드 확장 후 연구자 집계중입니다. 잠시만 기다려주세요.'
            : this.keywordSearchLoadingMessage(targetKeyword);
        let pendingExpandedKeywords: string[] = [];

        const params: any = {
            keyword: targetKeyword,
            page: this.page,
            dump: this.dump,
            sort: this.sort,
            order: this.order,
            fuzzy: targetFuzzy ? 'true' : 'false',
            cache_token: this.ensureKeywordResultCacheToken(),
            cache_reset: options.resetCache === true ? 'true' : 'false'
        };

        if (this.selectedOrgs.length > 0) {
            params.facet_orgs = this.selectedOrgs.join('|');
        }
        if (this.selectedKeywords.length > 0) {
            params.facet_keywords = this.selectedKeywords.join('|');
        }

        if (targetFuzzy) {
            reusableExpandedKeywords = this.canReuseExpandedKeywords(params.keyword) ? this.expandedKeywords : [];
            hasReusableExpandedKeywords = this.hasUsefulExpandedKeywords(
                reusableExpandedKeywords,
                this.normalizeKeywordTerm(params.keyword)
            );
            shouldRequestKeywordExpansion = !hasReusableExpandedKeywords && !reuseResultCache;
            if (hasReusableExpandedKeywords) {
                params.expanded_keywords = JSON.stringify(reusableExpandedKeywords);
            }
        }

        if (shouldShowKeywordLoadingCard) {
            this.startKeywordExpansionStatus(keywordLoadingMessage);
        } else {
            this.clearKeywordExpansionStatus();
        }
        await this.service.render();

        try {
            if (targetFuzzy) {
                if (!hasReusableExpandedKeywords && !reuseResultCache) {
                    requestPhase = 'keyword_expand';
                    try {
                        const { code: expandCode, data: expandData } = await wiz.call("keyword_expand", {
                            keyword: params.keyword
                        });

                        if (requestSeq !== this.keywordSearchRequestSeq) {
                            return;
                        }

                        if (expandCode === 200) {
                            const expandedSearchKeyword = String(expandData.search_keyword || params.keyword || '').trim();
                            if (expandedSearchKeyword) {
                                params.keyword = expandedSearchKeyword;
                            }
                            const expandedKeywords = this.normalizeExpandedKeywords(expandData.expanded_keywords || []);
                            const hasUsefulExpansion = this.hasUsefulExpandedKeywords(
                                expandedKeywords,
                                this.normalizeKeywordTerm(params.keyword)
                            );
                            keywordExpansionError = hasUsefulExpansion
                                ? ''
                                : this.keywordExpansionErrorFromResponse(expandData);
                            this.keywordExpansionModelError = keywordExpansionError;
                            if (hasUsefulExpansion) {
                                pendingExpandedKeywords = expandedKeywords;
                                params.expanded_keywords = JSON.stringify(expandedKeywords);
                            }
                            await this.service.render();
                        } else {
                            keywordExpansionError = '';
                            keywordStatusError = null;
                            this.clearKeywordExpansionModelError();
                            console.warn('[KORENET] keyword expansion fallback', {
                                code: expandCode,
                                message: expandData?.message || expandData?.error || ''
                            });
                        }
                    } catch (expandError) {
                        if (requestSeq !== this.keywordSearchRequestSeq) {
                            return;
                        }
                        keywordExpansionError = '';
                        keywordStatusError = null;
                        this.clearKeywordExpansionModelError();
                        console.warn('[KORENET] keyword expansion fallback', expandError);
                    }
                }
            }

            requestPhase = 'keyword_search';
            const { code, data } = await wiz.call("keyword_search", params);

            if (requestSeq !== this.keywordSearchRequestSeq) {
                return;
            }

            if (code === 200) {
                const responseSearchKeyword = String(data.search_keyword || params.keyword || '').trim();
                if (responseSearchKeyword) {
                    params.keyword = responseSearchKeyword;
                }
                const nextRows = data.rows || [];
                const nextTotal = data.total || 0;
                const nextExpandedKeywords = targetFuzzy
                    ? this.normalizeExpandedKeywords(data.expanded_keywords || pendingExpandedKeywords)
                    : [];
                const responseExpansionError = targetFuzzy ? this.keywordExpansionErrorFromResponse(data) : '';
                this.freezeRenderedMatchedKeywords(nextRows, params.keyword);
                if (requestSeq !== this.keywordSearchRequestSeq) {
                    return;
                }
                this.rows = nextRows;
                this.total = nextTotal;
                this.expandedKeywords = nextExpandedKeywords;
                this.showAllExpandedKeywords = false;
                this.keywordExpansionModelError = targetFuzzy ? (keywordExpansionError || responseExpansionError) : '';
                const responseStatusError = this.keywordSearchStatusFromResponse(data, '', 'search');
                if (responseStatusError) {
                    this.setKeywordSearchStatusError(responseStatusError.title, responseStatusError.message, responseStatusError);
                } else if (keywordStatusError) {
                    this.setKeywordSearchStatusError(keywordStatusError.title, keywordStatusError.message, keywordStatusError);
                } else {
                    this.clearKeywordSearchStatusError();
                }
                this.lastPage = Math.ceil(this.total / this.dump) || 1;
                searchSucceeded = true;
            } else {
                const responseStatusError = this.keywordSearchStatusFromResponse(
                    data,
                    data?.message || data?.error || 'keyword search failed',
                    'search'
                );
                if (responseStatusError) {
                    this.setKeywordSearchStatusError(responseStatusError.title, responseStatusError.message, responseStatusError);
                }
            }
        } catch (e) {
            if (targetFuzzy && requestPhase === 'keyword_expand' && this.isAiModelProblemMessage(e?.message || e)) {
                keywordExpansionError = this.keywordExpansionModelNotice;
                this.keywordExpansionModelError = keywordExpansionError;
            } else {
                const responseStatusError = this.keywordSearchStatusFromResponse(
                    null,
                    e?.message || e || `${requestPhase} failed`,
                    requestPhase === 'keyword_expand' ? 'expand' : 'search'
                );
                if (responseStatusError) {
                    this.setKeywordSearchStatusError(
                        responseStatusError.title,
                        responseStatusError.message,
                        { ...responseStatusError, originalError: e }
                    );
                }
            }
        } finally {
            if (requestSeq === this.keywordSearchRequestSeq) {
                this.loading = false;
                this.updateUrlParams();
                if (shouldShowKeywordLoadingCard) {
                    await this.service.render();
                    if (requestSeq === this.keywordSearchRequestSeq) {
                        this.clearKeywordExpansionStatus();
                        await this.service.render();
                    }
                } else {
                    this.clearKeywordExpansionStatus();
                    await this.service.render();
                }
            }
        }
        return searchSucceeded;
    }

    public async loadKeywordFacets(retryCount: number = 0) {
        const targetText = this.getRenderedSearchText();
        if (!targetText || this.renderedSearchTab !== 'keyword') {
            this.stopFacetLoading();
            return;
        }
        this.clearFacetPollTimer();
        const requestSeq = ++this.facetRequestSeq;
        const targetFuzzy = this.normalizeFuzzy('keyword', this.renderedFuzzySearch);
        this.renderedFuzzySearch = targetFuzzy;
        this.startFacetLoading();
        this.showAllOrgs = false;
        this.keywordsLimit = 30;
        try {
            const params: any = {
                keyword: targetText,
                fuzzy: targetFuzzy ? 'true' : 'false',
                cache_token: this.ensureKeywordResultCacheToken(),
                wait_seconds: 0
            };
            if (targetFuzzy && this.canReuseExpandedKeywords(targetText)) {
                params.expanded_keywords = JSON.stringify(this.expandedKeywords);
            }
            const { code, data } = await wiz.call("keyword_facets", params);
            if (code === 200 && requestSeq === this.facetRequestSeq
                && this.renderedSearchTab === 'keyword'
                && this.getRenderedSearchText() === targetText
                && this.renderedFuzzySearch === targetFuzzy) {
                if (data?.keyword_facets_pending) {
                    const facetJobState = String(data.keyword_facets_job_state || 'running');
                    if (facetJobState === 'error') {
                        const facetStatusError = this.keywordSearchStatusFromResponse(
                            data,
                            data?.keyword_facets_job_detail || 'keyword facets failed',
                            'facets'
                        );
                        if (facetStatusError) {
                            this.setKeywordSearchStatusError(facetStatusError.title, facetStatusError.message, facetStatusError);
                        }
                    } else {
                        this.clearKeywordFacetStatusError();
                        this.scheduleKeywordFacetPoll(
                            requestSeq,
                            targetText,
                            targetFuzzy,
                            retryCount,
                            data.retry_after_ms
                        );
                        return;
                    }
                }
                if (!data?.keyword_facets_pending) {
                    this.clearKeywordFacetStatusError();
                }
                this.facets = this.normalizeFacetPayload({
                    orgs: data.orgs || [],
                    keywords: data.keywords || []
                });
                if (targetFuzzy && data.expanded_keywords) {
                    const facetSearchKeyword = String(data.search_keyword || targetText || '').trim();
                    const facetExpandedKeywords = this.normalizeExpandedKeywords(data.expanded_keywords || []);
                    if (this.hasUsefulExpandedKeywords(facetExpandedKeywords, this.normalizeKeywordTerm(facetSearchKeyword))) {
                        this.expandedKeywords = facetExpandedKeywords;
                        this.showAllExpandedKeywords = false;
                    }
                }
                const facetModelError = this.keywordExpansionErrorFromResponse(data);
                if (targetFuzzy && facetModelError) {
                    this.keywordExpansionModelError = facetModelError;
                }
                const facetStatusError = this.keywordSearchStatusFromResponse(data, '', 'facets');
                if (facetStatusError) {
                    this.setKeywordSearchStatusError(facetStatusError.title, facetStatusError.message, facetStatusError);
                }
            } else if (code !== 200 && requestSeq === this.facetRequestSeq) {
                const facetStatusError = this.keywordSearchStatusFromResponse(
                    data,
                    data?.message || data?.error || 'keyword facets failed',
                    'facets'
                );
                if (facetStatusError) {
                    this.setKeywordSearchStatusError(facetStatusError.title, facetStatusError.message, facetStatusError);
                }
            }
        } catch (e) {
            if (requestSeq === this.facetRequestSeq) {
                this.clearKeywordFacetStatusError();
                this.scheduleKeywordFacetPoll(
                    requestSeq,
                    targetText,
                    targetFuzzy,
                    retryCount,
                    5000
                );
                return;
            }
        }
        if (requestSeq === this.facetRequestSeq) {
            this.stopFacetLoading();
            await this.service.render();
        }
    }

    public async onSearch() {
        const nextText = String(this.searchText || '').trim();
        const nextTab = this.normalizeSearchTab(this.searchTab);

        if (!nextText) {
            this.keywordSearchRequestSeq++;
            this.clearKeywordExpansionStatus();
            this.clearKeywordExpansionModelError();
            this.clearKeywordSearchStatusError();
            this.setRenderedSearchState(nextTab, '', this.fuzzySearch);
            this.rows = [];
            this.total = 0;
            this.loading = false;
            this.page = 1;
            this.showFilters = false;
            this.stopFacetLoading();
            this.resetFacetState(true);
            this.showEmptyGuide = true;
            this.updateUrlParams();
            await this.service.render();
            return;
        }
        const tabChanged = nextTab !== this.renderedSearchTab;
        this.searchTab = nextTab;
        this.searchText = nextText;
        this.setRenderedSearchState(nextTab, nextText, this.fuzzySearch);
        this.sort = tabChanged ? this.getDefaultSort(nextTab) : this.normalizeSort(this.sort, nextTab);
        this.showEmptyGuide = false;
        this.page = 1;
        this.resetFacetState(true);
        this.clearRenderedResultsForNewSearch();
        this.enforceFuzzyForCurrentTab();
        this.renderedFuzzySearch = this.normalizeFuzzy(nextTab, this.fuzzySearch);
        if (nextTab === 'keyword') {
            const keywordLoaded = await this.loadByKeyword(1, { searchText: nextText });
            if (keywordLoaded) {
                this.loadKeywordFacets();
            }
        } else {
            await this.load(1, { searchText: nextText, resetCache: true });
            this.loadFacets();
        }
    }

    public async changeTab(tab: string) {
        this.searchTabDropdownOpen = false;
        this.searchTab = this.normalizeSearchTab(tab);
        this.fuzzySearch = this.getDefaultFuzzy(this.searchTab);
        await this.service.render();
    }

    public async toggleSearchTabDropdown(event: Event) {
        event.stopPropagation();
        this.searchTabDropdownOpen = !this.searchTabDropdownOpen;
        await this.service.render();
    }

    public async selectSearchTab(tab: string, event?: Event) {
        if (event) event.stopPropagation();
        const nextTab = this.normalizeSearchTab(tab);
        if (nextTab === this.searchTab) {
            this.searchTabDropdownOpen = false;
            await this.service.render();
            return;
        }
        await this.changeTab(nextTab);
    }

    public async changeSort(sortValue: string) {
        const nextSort = this.normalizeSort(sortValue, this.renderedSearchTab);
        if (nextSort === this.sort || this.sortRequestInFlight) {
            return;
        }
        this.sort = nextSort;
        this.page = 1;
        this.sortRequestInFlight = true;
        try {
            if (this.isKeywordResultMode()) {
                await this.loadByKeyword(1, {
                    reuseResultCache: true,
                    showKeywordLoadingCard: false
                });
            } else {
                await this.load(1, { showResearcherLoadingCard: false });
            }
        } finally {
            this.sortRequestInFlight = false;
        }
    }

    public async toggleFilters() {
        this.showFilters = !this.showFilters;
        if (this.showFilters && this.facetLoading && !this.hasFacetData) {
            this.facetSkeletonVisible = true;
        }
        await this.service.render();
    }

    public goResearcher(id: string, row: any = null) {
        // 검색 상태를 sessionStorage에 저장 (뒤로가기 시 복원용)
        this.saveSearchStateSnapshot();
        window.open(this.buildResearcherDetailUrl(id, row), '_blank', 'noopener,noreferrer');
    }

    public async toggleFuzzySearch() {
        if (this.searchTab !== 'keyword') {
            this.fuzzySearch = false;
        } else {
            this.fuzzySearch = !this.fuzzySearch;
        }
        await this.service.render();
    }

    public async pageMove(page: number) {
        if (this.isKeywordResultMode()) {
            this.facetRequestSeq++;
            this.stopFacetLoading();
            await this.loadByKeyword(page, {
                reuseResultCache: true,
                showKeywordLoadingCard: false
            });
        } else {
            await this.load(page);
        }
    }

    public _getAllTags(row: any): string[] {
        if (!row) return [];
        const korKeywords = this.normalizeKeywordList(row.keyword_kor);
        if (korKeywords.length > 0) return this.uniqueKeywords(korKeywords);
        return this.uniqueKeywords(this.normalizeKeywordList(row.keyword_eng));
    }

    public getVisibleTags(row: any): string[] {
        return this._getAllTags(row).slice(0, 3);
    }

    public getExtraTagCount(row: any): number {
        const all = this._getAllTags(row);
        return Math.max(0, all.length - 3);
    }

    public isPopoverOpen(researcherId: string): boolean {
        return this.popoverCardId === researcherId;
    }

    public async togglePopover(event: Event, researcherId: string) {
        event.stopPropagation();
        if (this.popoverCardId === researcherId) {
            this.popoverCardId = '';
        } else {
            this.popoverCardId = researcherId;
        }
        await this.service.render();
    }

    public getFieldTags(fields: string): string[] {
        if (!fields) return [];
        return fields.split(/[;|]/).map(f => f.trim()).filter(f => f).slice(0, 3);
    }

    public getInitial(name: string): string {
        if (!name) return '?';
        return name.charAt(0);
    }

}

export default PageSearchComponent;